import { render, staticRenderFns } from "./ProductPlacement.vue?vue&type=template&id=d232d8a8&scoped=true"
import script from "./ProductPlacement.vue?vue&type=script&lang=js"
export * from "./ProductPlacement.vue?vue&type=script&lang=js"
import style0 from "./ProductPlacement.vue?vue&type=style&index=0&id=d232d8a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d232d8a8",
  null
  
)

export default component.exports